import {FETCH_TYPES, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import FetchAjax from "../FetchAjax";
import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import IConnectControl from "../controllers/IConnectControl";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";
import {wait} from "../../helpers";
import {getDeviceStr} from "../../device/device";

class ConnectAjaxGetDeviceOpt extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.GET_DEVICE_OPT;
    timeout: number = 20000;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {
        super(config, control, fetch, dom);

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).device_settings > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).device_settings * 1000;
        }
        this.setMethod(this.config.get(CONFIG_PARAMS.URL_GET_DEVICE_OPT_METHOD));
    }

    async fetch(data) {
        this.control.reset();
        this.data = data;

        return this._fetch();
    }

    protected getParams(): Record<string, any> {
        return {};
    }

    protected getUrl(): string {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_GET_DEVICE_OPT), {
            "casino_id": this.config.get(CONFIG_PARAMS.CASINO_ID),
            "player_id": this.config.get(CONFIG_PARAMS.PLAYER_ID),
            "device": getDeviceStr()
        });
    }
}

export default ConnectAjaxGetDeviceOpt;